// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-H":"H_power-ocean-home-H__QODOq"};